import { browserHistory } from 'react-router'
import api from '../../../api'
import moment from 'moment'
import test_modules from 'test_modules'
const PATIENT_URL = 'patients/'
import { changeLoading } from '../../Main/modules/main'
export const GET_DETAIL = 'GET_DETAIL'
export const UPDATE_PATIENT_DETAIL_STATE = 'UPDATE_PATIENT_DETAIL_STATE'
export const TEXT_CHANGE = 'TEXT_CHANGE'
export const UPDATE_PATIENT_EXAMS = 'UPDATE_PATIENT_EXAMS'
export const CLOSE_DIALOG = 'CLOSE_DIALOG'
let dateFormat = configModule.language.dateTimeFormat

import { serverUrl, apiUrl } from '../../../../config/react'
import configModule from 'config'
import config from '../../../../modules/config'

export function closeDialog() {
  return (dispatch, getState) => {
    closeEmailPopup()
    closeDeletePatientPopup()
    dispatch(updatePatientState('open', false))
  }
}

export function openEmailPopup() {
  return (dispatch, getState) => {
    let patientDetail = { ...getState().patientDetail }
    patientDetail.showEmailForm = true
    patientDetail.emailSend = patientDetail.currentTest.patient.profile.email
      ? patientDetail.currentTest.patient.profile.email
      : null
    patientDetail.subject = 'Instapap Test Results'
    dispatch({
      type: UPDATE_PATIENT_DETAIL_STATE,
      payload: patientDetail
    })
  }
}

export function closeEmailPopup() {
  return (dispatch, getState) => {
    let patientDetail = { ...getState().patientDetail }
    patientDetail.showEmailForm = false
    dispatch({
      type: UPDATE_PATIENT_DETAIL_STATE,
      payload: patientDetail
    })
  }
}

export function closeDeletePatientPopup() {
  return (dispatch, getState) => {
    let patientDetail = { ...getState().patientDetail }
    patientDetail.showDeletePatientPopup = false
    dispatch({
      type: UPDATE_PATIENT_DETAIL_STATE,
      payload: patientDetail
    })
  }
}

export function processDeletePatientPopup() {
  return (dispatch, getState) => {
    let patientDetail = { ...getState().patientDetail }

    return new Promise((resolve, reject) => {
      api.delete('/patients/' + patientDetail._id).then(
        response => {
          browserHistory.goBack()
          resolve()
        },
        error => {
          dispatch({
            type: UPDATE_PATIENT_DETAIL_STATE,
            payload: patientDetail
          })
          reject()
        }
      )
    })
  }
}

export function getPdf(testId){
  return (dispatch, getState) => {
    let locale = {...getState().locale};
    let newWin = window.open('','null','height=500,width=500,status=no, toolbar=no,menubar=no,location=no');
    return new Promise((resolve, reject) => {
      function reqListener () {
        let newBlob = new Blob([this.response], {type: "application/pdf"});
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        let urlCreator = window.URL || window.webkitURL;
        let data = urlCreator.createObjectURL(newBlob);

        if(!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
          let link = document.createElement('a');
          link.href = data;
          link.click();
        } else {
          newWin.location.href = data;
        }
        setTimeout(function(){
          // For Firefox it is necessary to delay revoking the ObjectURL
          urlCreator.revokeObjectURL(data);
        }, 100);
      }
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", reqListener);
      oReq.open("POST", serverUrl + apiUrl + "/pdf/" + testId + '?language=' + locale.options.defaultLanguage);
      oReq.setRequestHeader("authorization", "Basic "+localStorage.getItem('access_token'));
      oReq.setRequestHeader('Content-Transfer-Encoding', 'base64');
      oReq.responseType = "arraybuffer";
      oReq.send();
    })
  }
}

export function sendEmail(testId) {
  return (dispatch, getState) => {
    let locale = {...getState().locale};
    let patientDetail = getState().patientDetail
    let data = {
      email: patientDetail.emailSend,
      subject: patientDetail.subject,
      body: patientDetail.emailBody
    }
    api
      .post(
        '/pdf/' + testId + '/email?language=' + locale.options.defaultLanguage,
        data,
        true
      )
      .then(
        response => {
          dispatch(updatePatientState('open', true))
        },
        err => {
          dispatch(updatePatientState('showEmailForm', false))
          dispatch(updatePatientState('PopupContent', 'Send Email Fail'))
          dispatch(updatePatientState('sendEmail', true))
          dispatch(updatePatientState('showConfirmNextStep', true))
          // console.log(err);
        }
      )
  }
}

export function saveFile(url) {
  if (document.fileWindow) {
    document.fileWindow.close()
  }
  var fileWindow = window.open(
    url,
    '_blank',
    'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes'
  )
}

export function getPastTest() {
  return (dispatch, getState) => {
    var patients = { ...getState().patientDetail }
    var id = patients._id
    return new Promise((resolve, reject) => {
      api.get('/search/patient/' + id + '/instapap/history').then(
        response => {
          // console.log(response);
        },
        err => {
          // console.log(err);
        }
      )
      resolve()
    })
  }
}

export function getPatientDetail(id) {
  return (dispatch, getState) => {
    let locale = {...getState().locale};
    dateFormat = config.languages[locale.options.defaultLanguage].dateTimeFormat;
    return new Promise((resolve, reject) => {
      let patientDetail = { ...getState().patientDetail }
      api
        .get('/patients/' + id, {})
        .then(
          response => {
            let tabIndex = 0

            if (patientDetail.tabIndex) {
              tabIndex = patientDetail.tabIndex
            }
            patientDetail = response.patient
            patientDetail.tabIndex = tabIndex
            patientDetail.profile.date = {}
            patientDetail.profile.date.dob = patientDetail.profile.dob
              ? moment(patientDetail.profile.dob).format(dateFormat)
              : ''
            patientDetail.profile.date.last_visit = patientDetail.profile
              .last_visit
              ? moment(patientDetail.profile.last_visit).format(dateFormat)
              : ''
            patientDetail.profile.date.next_visit =
              patientDetail.profile.next_visit &&
              patientDetail.profile.next_visit.appt_date
                ? moment(patientDetail.profile.next_visit.appt_date).format(
                    dateFormat
                  )
                : ''
            return id
          },
          err => {
            dispatch({
              type: GET_DETAIL,
              payload: err
            })
            reject()
          }
        )
        .then(id => {
          getExamsOfPatient(id).then(
            exams => {
              if (exams.length != 0) {
                patientDetail.currentNote = {
                  index: 0,
                  content: exams[0].notes.report
                }
              }
              patientDetail.exams = []
              exams.map(test => {
                if (test.data && test.data.IMP) {
                  test.data.IMPcustom = []
                  if (test.data.IMP.length < 16) {
                    test.data.typeImage = 'FALSE'
                  }
                  if (test.data.IMP.length == 16) {
                    test.data.typeImage = 'FOUR'
                  }
                  if (test.data.IMP.length > 16 && test.data.IMP.length <= 20) {
                    test.data.typeImage = 'FIVE'
                  }
                  if (test.data.IMP.length > 20) {
                    test.data.typeImage = 'SIX'
                  }
                  test.data.IMP.map(imp => {
                    let temp = 0
                    imp.ID.map(k => {
                      temp += parseInt(k)
                    })
                    test.data.IMPcustom.push(temp)
                  })
                }
                patientDetail.exams.push(test)
              })
              dispatch({
                type: GET_DETAIL,
                payload: patientDetail
              })
              resolve()
            },
            error => {
              dispatch({
                type: GET_DETAIL,
                payload: error
              })
              reject()
            }
          )
        })
    })
  }
}

function convertToCodinations(data) {
  let result = []
  // define step
  let min = data[0][0][0]
  let max = 0

  data.map((line, k) => {
    line.map((point, n) => {
      if (point[0] >= max) {
        max = point[0]
      }
      if (point[0] <= min) {
        min = point[0]
      }
    })
  })
  let step = Math.ceil((max - min) / data.length)
  // transform graph
  data.map((line, i) => {
    result.push({ x: min + step * i })
  })

  data.map((line, i) => {
    line.map((point, j) => {
      let index = checkIndex(Math.ceil((point[0] - min) / step), 0, data.length)
      result[index]['y' + i] = point[1]
    })
  })
  return result
}

function checkIndex(index, bound1, bound2) {
  let rs = index
  if (index < bound1) {
    rs = bound1
  }
  if (index >= bound2) {
    rs = bound2 - 1
  }
  return rs
}

export function getPatientHistory(id) {
  return new Promise((resolve, reject) => {
    api.get('/search/patient/' + id + '/instapap/history', {}).then(
      response => {
        resolve(response.exams)
      },
      err => {
        reject(false)
      }
    )
  })
}

function _buildTime(time, plusHour) {
  plusHour = plusHour || false;
  if (!time) {
    return ''
  }

  Date.prototype.addHours = function(h){
    this.setHours(this.getHours()+h);
    return this;
  }

  // let bd = time.slice(11, 16);
  let h = !plusHour ? new Date(time).getHours() : (new Date(time).addHours(plusHour)).getHours()
  let m = new Date(time).getMinutes()
  if (h < 10) {
    h = '0' + h
  }
  if (m < 10) {
    m = '0' + m
  }
  return h + ':' + m
}

export function getNote(test, index) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail.currentNote = {}
      patientDetail.currentNote.index = index
      patientDetail.currentNote.content = test.notes.report
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}

function getFakeAPI() {
  return new Promise((resolve, reject) => {
    setTimeout(function() {
      let data = [
        {
          name: 'Colposcopy',
          result: 'Normal',
          score: '12/16',
          status: 'pass',
          file: 'Patient283.pdf',
          date: '12/05/16',
          note: 'That is a note for that test 1111'
        },
        {
          name: 'PapSmear',
          result: 'Moderate dysplasia',
          score: '12/16',
          status: 'notpass',
          file: 'Patient283.pdf',
          date: '12/05/16',
          note: 'That is a note for that test 2222'
        },
        {
          name: 'InstaPap',
          result: 'Very mild/ mild dysplasia',
          score: '12/16',
          status: 'not pass',
          file: 'Patient283.pdf',
          date: '12/05/16',
          note: 'That is a note for that test 3333'
        },
        {
          name: 'Biopsy',
          result: 'Invasive carcinoma',
          score: '12/16',
          status: 'pass',
          file: 'Patient283.pdf',
          date: '12/05/16',
          note: 'That is a note for that test 4444'
        }
      ]
      resolve(data)
    }, 500)
  })
}

export function patientStateConstructor(key, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      getFakeAPI().then(data => {
        var patientDetail = { ...getState().patientDetail }
        patientDetail['noteList'] = data
        dispatch({
          type: UPDATE_PATIENT_DETAIL_STATE,
          payload: patientDetail
        })
        resolve()
      })
    })
  }
}

export function abandonTest() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      api
        .delete('/exams/instapap/', { exam_id: patientDetail.examTemp._id })
        .then(
          response => {
            patientDetail.showPupupCriteria = false
            patientDetail.showWaitingDockDevicePop = false
            patientDetail.exclusionCriteria = false
            patientDetail.showInterviewPopup = false
            patientDetail.exclusionCriteria = false
            dispatch({
              type: UPDATE_PATIENT_DETAIL_STATE,
              payload: patientDetail
            })
            resolve()
          },
          err => {
            dispatch({
              type: UPDATE_PATIENT_DETAIL_STATE,
              payload: patientDetail
            })
            resolve()
          }
        )
    })
  }
}

export function updateNewInterview(key, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      if (
        !patientDetail.newInterview ||
        typeof patientDetail.newInterview != 'object'
      ) {
        patientDetail.newInterview = {}
      }
      patientDetail.newInterview[key] = value
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}

export function createTest() {
  return (dispatch, getState) => {
    function createExamApi(startTime, newTest, cb) {
      var currentPatientDetail = { ...getState().patientDetail }
      let timer = Number(new Date())
      if (currentPatientDetail.disConnect) {
        dispatch(updatePatientState('disConnect', false))
        dispatch(updatePatientState('showWaitingDockDevicePop', false))
        return cb(null)
      }
      if (Number(new Date()) - startTime < 1200000) {
        let created_at = currentPatientDetail.newTestTime
        api.post('/exams/instapap?created_at=' + created_at, {}, true).then(
          response => {
            if (response.status == false) {
              let timePerRequest = Number(new Date()) - timer
              if (timePerRequest >= 10000) {
                return createExamApi(startTime, newTest, cb)
              }
              setTimeout(function() {
                return createExamApi(startTime, newTest, cb)
              }, 10000 - timePerRequest)
            } else {
              dispatch(updatePatientState('newTestTime', false))
              dispatch(updatePatientState('showWaitingDockDevicePop', false))
              return cb(response)
            }
          },
          err => {
            return createExamApi(startTime, newTest, cb)
          }
        )
      } else {
        dispatch(updatePatientState('showWaitingDockDevicePop', false))
        dispatch(updatePatientState('showPopupDockDeviceComplete', true))
        return cb(null)
      }
    }
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let data = {
        patient: patientDetail._id
      }
      dispatch(updatePatientState('showWaitingDockDevicePop', true))
      let startTime = new Date()
      createExamApi(startTime, data, function(res) {
        if (res) {
          dispatch(updatePatientState('examTemp', res.exam))
          dispatch(updatePatientState('showPupupCriteria', false))
          dispatch(updatePatientState('showInterviewPopup', true))
        } else {
          console.log('fail')
        }
      })
    })
  }
}

export function updateNewTest() {
  let commonKeys = [
    'reason_for_appt',
    'hereditary_predis',
    'personal_predis',
    'pathological_predis'
  ]
  let symp_presentKeys = [
    'vaginal_discharge',
    'postcoital_bleeding',
    'cervical_bleeding',
    'symp_present_other'
  ]
  let observed_conditionsKeys = [
    'smooth',
    'inflammation',
    'hypertrophy',
    'polyp',
    'nabothian_cyst',
    'leceration',
    'leucoplasia',
    'supspicious_lesion',
    'observed_conditions_other'
  ]
  let notesKeys = ['report', 'physical', 'current_condition']
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let data = {
        _id: patientDetail.examTemp._id,
        symp_present: [],
        obs_conditions: [],
        notes: {},
        patient: patientDetail._id
      }
      symp_presentKeys.forEach(item => {
        let temp = {}
        temp[item] = false
        data.symp_present.push(temp)
      })
      observed_conditionsKeys.forEach(item => {
        let temp = {}
        temp[item] = false
        data.obs_conditions.push(temp)
      })
      if (!patientDetail.newInterview) {
        patientDetail.newInterview = {}
      }
      if (!patientDetail.newInterview.cervical_bleeding) {
        patientDetail.newInterview.cervical_bleeding = 1
      }
      Object.keys(patientDetail.newInterview || []).map((key, index) => {
        if (commonKeys.indexOf(key) > -1) {
          data[key] = patientDetail.newInterview[key]
        }
        if (symp_presentKeys.indexOf(key) > -1) {
          let temp = {}
          temp[key] = patientDetail.newInterview[key]
          data.symp_present[symp_presentKeys.indexOf(key)] = temp
        }
        if (observed_conditionsKeys.indexOf(key) > -1) {
          let temp = {}
          temp[key] = patientDetail.newInterview[key]
          data.obs_conditions[observed_conditionsKeys.indexOf(key)] = temp
        }
        if (notesKeys.indexOf(key) > -1) {
          data.notes[key] = patientDetail.newInterview[key]
        }
      })
      data.pre_conditions = []
      data.pre_conditions = test_modules.pre_conditionsKeys.map(function(
        item,
        i
      ) {
        let temp = {}
        if (!patientDetail.exclusionCriteria) {
          patientDetail.exclusionCriteria = {}
        }
        if (patientDetail.exclusionCriteria[item]) {
          temp[test_modules.pre_conditionsKeys[i]] = true
          return temp
        } else {
          temp[test_modules.pre_conditionsKeys[i]] = false
          return temp
        }
      })
      api.put('/exams', data, true).then(
        response => {
          if (response.exam.data) {
            response.exam.data.IMPcustom = []
            if (response.exam.data.IMP.length < 16) {
              response.exam.data.typeImage = 'FALSE'
            }
            if ((response.exam.data.IMP.length == 16)) {
              response.exam.data.typeImage = 'FOUR'
            }
            if (
              response.exam.data.IMP.length > 16 &&
              response.exam.data.IMP.length <= 20
            ) {
              response.exam.data.typeImage = 'FIVE'
            }
            if (response.exam.data.IMP.length > 20) {
              response.exam.data.typeImage = 'SIX'
            }
            response.exam.data.IMP.map(imp => {
              let temp = 0
              imp.ID.map(k => {
                temp += parseInt(k)
              })
              response.exam.data.IMPcustom.push(temp)
            })
          }
          if (response.exam.imp && response.exam.imp.length > 0) {
            response.exam.impCordinations = []
            response.exam.impCordinations.push(
              convertToCodinations(response.exam.imp[0])
            )
            response.exam.impCordinations.push(
              convertToCodinations(response.exam.imp[1])
            )
            response.exam.impCordinations.push(
              convertToCodinations(response.exam.imp[2])
            )
          }
          if (response.exam.optical && response.exam.optical.length > 0) {
            response.exam.opticalCordinations = convertToCodinations(
              response.exam.optical
            )
          }
          dispatch(updatePatientState('showInterviewPopup', false))
          dispatch(updatePatientState('currentTest', response.exam))
          dispatch(updatePatientState('showResult', true))
          dispatch(updatePatientState('updateExams', response.exam))
        },
        err => {
          console.log(err)
          dispatch(updatePatientState('showInterviewPopup', false))
        }
      )
    })
  }
}

//GVANCE CODE

// export function updateNewTest(){
//   let pre_conditionsKeys = [
//         "patient_pregnant",
//         "patient_received_within_6_weeks",
//         "less_than_4_months_post_partum",
//         "patient_currently_menstrual",
//         "receiving_received_chemotherapy",
//         "previously_undergone_hysterectomy",
//         "received_surgical_treatment",
//         "received_radiotherapy_treatment",
//         "clinically_apparent_acute_subacute_infection",
//         "photosensitising_disease"
//   ];
//   let commonKeys = ["reason_for_appt","hereditary_predis","personal_predis","pathological_predis"];
//   let symp_presentKeys = ["vaginal_discharge","postcoital_bleeding","cervical_bleeding","symp_present_other"];
//   let observed_conditionsKeys = ["smooth","inflammation","hypertrophy","polyp","nabothian_cyst","leceration","leucoplasia","supspicious_lesion","observed_conditions_other"];
//   let notesKeys = ["report","physical","current_condition"];

//   return (dispatch, getState) => {
//     return new Promise((resolve, reject) => {
//           var patientDetail = { ...getState().patientDetail }
//           if(patientDetail.newInterview && !patientDetail.newInterview.cervical_bleeding){
//             patientDetail.newInterview.cervical_bleeding =1;
//           }
//           let data ={
//             _id : patientDetail.examTemp._id,
//             symp_present : [],
//             obs_conditions:[],
//             notes : {},
//             patient : patientDetail._id
//           }
//           symp_presentKeys.forEach(item=>{
//             let temp={};
//             temp[item] = false;
//             data.symp_present.push(temp);
//           })
//           observed_conditionsKeys.forEach(item=>{
//             let temp={};
//             temp[item] = false;
//             data.obs_conditions.push(temp);
// // <<<<<<< HEAD
//           });
//           Object.keys(patientDetail.newInterview || []).map((key,index)=>{
// // =======
// //           })
// //           if(!patientDetail.newInterview){
// //             patientDetail.newInterview = {};
// //           }
// //           Object.keys(patientDetail.newInterview).map((key,index)=>{
// // >>>>>>> 4132c12191d870c4d964d6303ee382b1bba4f406
//             if(commonKeys.indexOf(key)>-1){
//               data[key]=patientDetail.newInterview[key];
//             }
//             if(symp_presentKeys.indexOf(key)>-1 ){
//               let temp = {};
//               temp[key] = patientDetail.newInterview[key]
//               data.symp_present[symp_presentKeys.indexOf(key)] = temp;
//             }
//             if(observed_conditionsKeys.indexOf(key)>-1){
//               let temp = {};
//               temp[key] = patientDetail.newInterview[key]
//               data.obs_conditions[observed_conditionsKeys.indexOf(key)] = temp;
//             }
//             if(notesKeys.indexOf(key)>-1){
//               data.notes[key]=patientDetail.newInterview[key];
//             }
// // <<<<<<< HEAD
//           });
//           // data.pre_conditions =[];
//           // data.pre_conditions = ["mot","hai","ba","bon","nam","sau","bay","tam","chin","muoi"].map(function(item,i){
//           //   let temp={};
//           //   if(patientDetail.exclusionCriteria[item]){
//           //     temp[pre_conditionsKeys[i]] = true;
//           //     return temp;
//           //   }else{
//           //     temp[pre_conditionsKeys[i]] = false;
//           //     return temp;
//           //   }
//           // })
// // =======
// //           })
// //           data.pre_conditions =[];
// //           data.pre_conditions = ["mot","hai","ba","bon","nam","sau","bay","tam","chin","muoi"].map(function(item,i){
// //             let temp={};
// //             if(!patientDetail.exclusionCriteria){
// //               patientDetail.exclusionCriteria = {};
// //             }
// //             if(patientDetail.exclusionCriteria[item]){
// //               temp[pre_conditionsKeys[i]] = true;
// //               return temp;
// //             }else{
// //               temp[pre_conditionsKeys[i]] = false;
// //               return temp;
// //             }
// //           })
// //           data.time = new Date();
// // >>>>>>> 4132c12191d870c4d964d6303ee382b1bba4f406
//           api.put('/exams',data,true)
//           .then(response => {
//             if(response.exam.data){
//               response.exam.data.IMPcustom = []
//               if(response.exam.data.IMP.length <16){
//                 response.exam.data.typeImage = 'FALSE'
//               }
//               if(response.exam.data.IMP.length = 16){
//                 response.exam.data.typeImage = 'FOUR'
//               }
//               if(response.exam.data.IMP.length > 16 && response.exam.data.IMP.length <= 20){
//                 response.exam.data.typeImage = 'FIVE'
//               }
//               if(response.exam.data.IMP.length > 20){
//                 response.exam.data.typeImage = 'SIX'
//               }
//               response.exam.data.IMP.map((imp)=>{
//                 let temp = 0;
//                 imp.ID.map(k => {
//                   temp += parseInt(k);
//                 })
//                 response.exam.data.IMPcustom.push(temp)
//               })
//             }
//             if(response.exam.imp && response.exam.imp.length  > 0){
//               response.exam.impCordinations = []
//               response.exam.impCordinations.push(convertToCodinations(response.exam.imp[0]));
//               response.exam.impCordinations.push(convertToCodinations(response.exam.imp[1]));
//               response.exam.impCordinations.push(convertToCodinations(response.exam.imp[2]));
//             }
//             if(response.exam.optical && response.exam.optical.length > 0 ){
//               response.exam.opticalCordinations = convertToCodinations(response.exam.optical)
//             }
//             dispatch(updatePatientState("showInterviewPopup",false));
//             dispatch(updatePatientState("currentTest",response.exam));
//             dispatch(updatePatientState("showResult",true));
//           },err=>{
//             console.log(err);
//             dispatch(updatePatientState("showInterviewPopup",false));
//           })
//       })
//   }
// }

// export function createTest(){
//   return (dispatch, getState) => {
// // <<<<<<< HEAD
//     let created_at = new Date();
//     var createExamApi = function createExamApi(cb){
//       api.post('/exams/instapap?created_at='+created_at,{},true)
//         .then((response) => {
//           if(response.status == false) return setTimeout(function(){ createExamApi(cb) }, 1000);
// // =======
// //     function createExamApi(startTime,newTest,cb){
// //         var currentPatientDetail = { ...getState().patientDetail }
// //         if(currentPatientDetail.disConnect){
// //           dispatch(updatePatientState("disConnect",false))
// //           dispatch(updatePatientState("showWaitingDockDevicePop",false))
// //           return cb(null);
// //         }
// //         let timer = Number(new Date());
// //         if(Number(new Date()) - startTime < 10000 ){
// //           newTest.time = currentPatientDetail.newTestTime;
// //           api.post('/exams/instapap',newTest,true)
// //           .then(response => {
// //             if(response.status == false){
// //               let timePerRequest = Number(new Date()) - timer;
// //               if(timePerRequest >= 1000){
// //                 return createExamApi(startTime,newTest,cb);
// //               }
// //               setTimeout(function(){
// //                 return createExamApi(startTime,newTest,cb);
// //               }, 1000 - timePerRequest);
// //             }else{
// //               dispatch(updatePatientState("newTestTime",false));
// //               dispatch(updatePatientState("showWaitingDockDevicePop",false))
// //               return cb(response);
// //             }
// //           }, err => {
// //             return createExamApi(startTime,newTest,cb);
// //           })
// //         }else{
// // >>>>>>> 4132c12191d870c4d964d6303ee382b1bba4f406
//           dispatch(updatePatientState("showWaitingDockDevicePop",false))
//           return cb(response);
//         });
//     };
//     return new Promise((resolve, reject) => {
//         var patientDetail = { ...getState().patientDetail }
//         let data ={
//           patient : patientDetail._id
//         };

//         dispatch(updatePatientState("showWaitingDockDevicePop",true))

//         createExamApi(function(res){
//           if(res){
//             console.log(res);
//             dispatch(updatePatientState("examTemp",res.exam))
//             dispatch(updatePatientState("showPupupCriteria",false))
//             dispatch(updatePatientState("showInterviewPopup",true))
//           }else{
//             console.log("fail");
//           }
//         })
//     });
//         // var currentPatientDetail = { ...getState().patientDetail }
//         // if(currentPatientDetail.disConnect){
//         //   dispatch(updatePatientState("disConnect",false))
//         //   dispatch(updatePatientState("showWaitingDockDevicePop",false))
//         //   return cb(null);
//         // }
//         // let timer = Number(new Date());
//         // if(Number(new Date()) - startTime < 10000 ){
//         //   api.post('/exams/instapap',newTest,true)
//         //   .then(response => {
//         //     if(response.status == false){
//         //       let timePerRequest = Number(new Date()) - timer;
//         //       if(timePerRequest >= 1000){
//         //         return createExamApi(startTime,newTest,cb);
//         //       }
//         //       setTimeout(function(){
//         //         return createExamApi(startTime,newTest,cb);
//         //       }, 1000 - timePerRequest);
//         //     }else{
//         //       dispatch(updatePatientState("showWaitingDockDevicePop",false))
//         //       return cb(response);
//         //     }
//         //   }, err => {
//         //     return createExamApi(startTime,newTest,cb);
//         //   })
//         // }else{
//         //   dispatch(updatePatientState("showWaitingDockDevicePop",false))
//         //   dispatch(updatePatientState("showPopupDockDeviceComplete",true))
//         //   return cb(null);
//         // }
//     // return new Promise((resolve, reject) => {
//     //     var patientDetail = { ...getState().patientDetail }
//     //     let data ={
//     //       test_type : "Instapap", //PapSmear/Instapap/Colposcopy
//     //       status : 1,// 1 - normal, 2 - very mild / mild dysplasia, etc
//     //       test_date : new Date(),
//     //       results_date :new Date(),
//     //       results : [],
//     //       files : [],
//     //       symp_present : [],
//     //       obs_conditions:[],
//     //       notes : {},
//     //       patient : patientDetail._id
//     //     }
//     //     dispatch(updatePatientState("showWaitingDockDevicePop",true))
//     //     let startTime = new Date();
//     //     createExamApi(startTime,data,function(res){
//     //       if(res){
//     //         console.log(res);
//     //         dispatch(updatePatientState("examTemp",res.examTemp))
//     //         dispatch(updatePatientState("showPupupCriteria",false))
//     //         dispatch(updatePatientState("showInterviewPopup",true))
//     //       }else{
//     //         console.log("fail");
//     //       }
//     //     })
//     // })
//   }
// }

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}
function validatePhone(phone) {
  //var re = /^[\+]?[0-9]?[(]?[0-9]+[)]?[-\s\.]?[0-9]+[-\s\.]?[0-9]+$/im
	return true;
}
export function onChangeProfileState(key, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail.profileUpdateDate = patientDetail.profile
      switch (key) {
        case 'country':
          patientDetail.profileUpdateDate.address.country = value
          break
        case 'zip':
          patientDetail.profileUpdateDate.address.zip = value
          break
        case 'state':
          patientDetail.profileUpdateDate.address.state = value
          break
        case 'city':
          patientDetail.profileUpdateDate.address.city = value
          break
        case 'lines':
          patientDetail.profileUpdateDate.address.lines = value
          break
        case 'lastName':
          patientDetail.profileUpdateDate.name.last = value
          if (patientDetail.profileUpdateDate.name.last.length == 0)
            patientDetail.profileUpdateDate.name.lastNameUnValid = true
          else patientDetail.profileUpdateDate.name.lastNameUnValid = false
          break
        case 'firstName':
          patientDetail.profileUpdateDate.name.first = value
          if (patientDetail.profileUpdateDate.name.first.length == 0)
            patientDetail.profileUpdateDate.name.firstNameUnValid = true
          else patientDetail.profileUpdateDate.name.firstNameUnValid = false
          break
        case 'phone':
          patientDetail.profileUpdateDate.phone = value
          if (
            !validatePhone(patientDetail.profileUpdateDate.phone) ||
            patientDetail.profileUpdateDate.phone.length < 8
          )
            patientDetail.profileUpdateDate.phoneUnValid = true
          else patientDetail.profileUpdateDate.phoneUnValid = false
          break
        case 'email':
          patientDetail.profileUpdateDate.email = value
          if (
            patientDetail.profileUpdateDate.email.length == 0 ||
            !validateEmail(patientDetail.profileUpdateDate.email)
          )
            patientDetail.profileUpdateDate.emailUnValid = true
          else patientDetail.profileUpdateDate.emailUnValid = false
          break
        case 'next_visit':
          // console.log("lslslsls",value);
          if (
            !patientDetail.profileUpdateDate.next_visit ||
            typeof patientDetail.profileUpdateDate.next_visit != 'object'
          )
            patientDetail.profileUpdateDate.next_visit = {}
          patientDetail.profileUpdateDate.next_visit.appt_date = value
          break
        default:
          patientDetail.profileUpdateDate[key] = value
      }
      // patientDetail.profileUpdateDate[key] = value
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}

export function updatePatientState(key, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail[key] = value
      let exam = {}
      switch (key) {
        case 'nextStep':
          exam._id = patientDetail.currentTest._id
          exam.patient = patientDetail._id
          if (patientDetail.currentTest.next_step) {
            patientDetail.currentTest.next_step.test = value
          } else {
            patientDetail.currentTest.next_step = {}
            patientDetail.currentTest.next_step.test = value
          }
          exam.next_step = patientDetail.currentTest.next_step
          apiUpdateExam([exam]).then(() => {
            dispatch({
              type: UPDATE_PATIENT_DETAIL_STATE,
              payload: patientDetail
            })
          })
          break
        case 'expectedResultDate':
          exam._id = patientDetail.currentTest._id
          exam.patient = patientDetail._id
          if (patientDetail.currentTest.next_step) {
            patientDetail.currentTest.next_step.expectedResultDate = value
          } else {
            patientDetail.currentTest.next_step = {}
            patientDetail.currentTest.next_step.expectedResultDate = value
          }
          exam.next_step = patientDetail.currentTest.next_step
          apiUpdateExam([exam]).then(() => {
            dispatch({
              type: UPDATE_PATIENT_DETAIL_STATE,
              payload: patientDetail
            })
          })
          break
        case 'nextApptDate':
          exam._id = patientDetail.currentTest._id
          exam.patient = patientDetail._id
          let date = new Date(value)
          if (!patientDetail.currentTest.follow_up) {
            patientDetail.currentTest.follow_up = new Date()
          }
          patientDetail.currentTest.follow_up = new Date(
            patientDetail.currentTest.follow_up
          )
          patientDetail.currentTest.follow_up.setYear(date.getFullYear())
          patientDetail.currentTest.follow_up.setMonth(date.getMonth())
          patientDetail.currentTest.follow_up.setDate(date.getDate())
          exam.follow_up = new Date(patientDetail.currentTest.follow_up)
          apiUpdateExam([exam]).then(() => {
            dispatch({
              type: UPDATE_PATIENT_DETAIL_STATE,
              payload: patientDetail
            })
          })
          break
        case 'nextApptTime':
          exam._id = patientDetail.currentTest._id
          exam.patient = patientDetail._id
          let time = new Date(value)
          if (!patientDetail.currentTest.follow_up) {
            patientDetail.currentTest.follow_up = new Date()
          }
          patientDetail.currentTest.follow_up = new Date(
            patientDetail.currentTest.follow_up
          )
          patientDetail.currentTest.follow_up.setHours(time.getHours())
          patientDetail.currentTest.follow_up.setMinutes(time.getMinutes())
          exam.follow_up = new Date(patientDetail.currentTest.follow_up)
          apiUpdateExam([exam]).then(() => {
            dispatch({
              type: UPDATE_PATIENT_DETAIL_STATE,
              payload: patientDetail
            })
          })
          break
        case 'showPopupEditResult':
          patientDetail.editResult = JSON.parse(
            JSON.stringify(patientDetail.exams)
          )
          break
        case 'newTestFile':
          if (value) {
            patientDetail.newTestFileName = value.split('/').pop()
          }
          break
        case 'updateExams':
          // let exam = data !== 'undefined' ? data : patientDetail.currentTest
          dispatch({
            type: UPDATE_PATIENT_EXAMS,
            payload: Object.assign({}, patientDetail, { exams: patientDetail.exams.concat(patientDetail.currentTest) })
          })
          console.log('UPDATE_PATIENT_EXAMS', value)
          break
        default:
          dispatch({
            type: UPDATE_PATIENT_DETAIL_STATE,
            payload: patientDetail
          })
      }
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}
export function updateTestScreen(test, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail.showResult = value
      patientDetail.currentTest = test
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}
function getExamsOfPatient(patientId) {
  return new Promise((resolve, reject) => {
    api
      .post('/exams/patients/' + patientId, {})
      .then(response => {
        response.exams.map((test, i) => {
          test.created_at_date = test.created_at
            ? moment(test.created_at).format(dateFormat)
            : ''
          test.created_at_time = test.created_at
            ? _buildTime(test.created_at)
            : ''
          test.results_date_date = test.results_date
            ? moment(test.results_date).format(dateFormat)
            : ''
          test.results_date_time = test.results_date
            ? _buildTime(test.results_date)
            : ''
          test.date_date = test.date ? moment(test.date).format(dateFormat) : ''
          test.date_time = test.date ? moment(test.date).add(1, "h").format("LT") : ''
          if (test.imp && test.imp.length > 0) {
            test.impCordinations = []
            test.impCordinations.push(convertToCodinations(test.imp[0]))
            test.impCordinations.push(convertToCodinations(test.imp[1]))
            test.impCordinations.push(convertToCodinations(test.imp[2]))
          }
          if (test.optical && test.optical.length > 0) {
            test.opticalCordinations = convertToCodinations(test.optical)
          }
        })
        response.exams = response.exams.filter(e => {
          return (
            (e.test_type.toLowerCase().localeCompare('instapap') !== 0 &&
              e.status) ||
            e.test_type.toLowerCase().localeCompare('instapap') === 0
          )
        })
        return response.exams
      })
      .then(
        exams => {
          resolve(exams)
        },
        error => {
          reject(error)
        }
      )
  })
}

function createExam(exam) {
  return new Promise((resolve, reject) => {
    api.post('/exams', exam).then(
      response => {
        resolve()
      },
      error => {
        console.log(error)
        reject()
      }
    )
  })
}
export function updateTestNote(index, content) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patientDetail = { ...getState().patientDetail }
      patientDetail.currentTest.notes[index] = content
      dispatch({
        type: GET_DETAIL,
        payload: patientDetail
      })
    })
  }
}

export function changeReportNote(content) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail.currentNote.content = content
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}

export function updateReportNote(value) {
  // console.log(value);
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail.currentNote.content = value
      let temp = {}
      temp.patient = patientDetail._id
      temp._id = patientDetail.exams[patientDetail.currentNote.index]._id
      temp.notes = {}
      temp.notes.report = value
      var tempArray = []
      tempArray.push(temp)
      apiUpdateExam(tempArray).then(
        response => {
          patientDetail.exams[patientDetail.currentNote.index].notes.report =
            patientDetail.currentNote.content
          dispatch({
            type: UPDATE_PATIENT_EXAMS,
            payload: patientDetail
          })
          resolve()
        },
        error => {
          dispatch({
            type: UPDATE_PATIENT_EXAMS,
            payload: error
          })
          reject()
        }
      )
    })
  }
}

export function deleteFile(exam) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let temp = {}
      temp.patient = patientDetail._id
      temp._id = exam._id
      temp.files = []
      apiUpdateExam([temp]).then(
        response => {
          getExamsOfPatient(patientDetail._id).then(
            exams => {
              patientDetail.exams = exams
              patientDetail.exams.map(test => {
                if (test.data) {
                  test.data.IMPcustom = []
                  if (test.data.IMP.length < 16) {
                    test.data.typeImage = 'FALSE'
                  }
                  if ((test.data.IMP.length = 16)) {
                    test.data.typeImage = 'FOUR'
                  }
                  if (test.data.IMP.length > 16 && test.data.IMP.length <= 20) {
                    test.data.typeImage = 'FIVE'
                  }
                  if (test.data.IMP.length > 20) {
                    test.data.typeImage = 'SIX'
                  }
                  test.data.IMP.map(imp => {
                    let temp = 0
                    imp.ID.map(k => {
                      temp += parseInt(k)
                    })
                    test.data.IMPcustom.push(temp)
                  })
                }
              })
              dispatch({
                type: GET_DETAIL,
                payload: patientDetail
              })
              resolve()
            },
            error => {
              dispatch({
                type: GET_DETAIL,
                payload: error
              })
              reject()
            }
          )
        },
        error => {
          dispatch({
            type: UPDATE_PATIENT_EXAMS,
            payload: error
          })
          reject()
        }
      )
    })
  }
}

export function updateExam(obj) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let temp = {}
      if (obj) {
        temp = obj
      } else {
        temp.patient = patientDetail._id
        temp._id = patientDetail.currentTest._id
        temp.notes = patientDetail.currentTest.notes
      }
      apiUpdateExam([temp]).then(
        response => {
          delete patientDetail.nextStep
          delete patientDetail.expectedResultDate
          dispatch({
            type: UPDATE_PATIENT_EXAMS,
            payload: patientDetail
          })
          resolve()
        },
        error => {
          delete patientDetail.nextStep
          delete patientDetail.expectedResultDate
          dispatch({
            type: UPDATE_PATIENT_EXAMS,
            payload: error
          })
          reject()
        }
      )
    })
  }
}

function apiUpdateExam(arrayExam) {
  return new Promise((resolve, reject) => {
    api.put('/exams/patients', arrayExam).then(
      response => {
        resolve(response)
      },
      error => {
        reject(error)
      }
    )
  })
}

export function updatePatientStatus(empty) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patientDetail = { ...getState().patientDetail }
      let newTest = {}
      let createFlag = true
      newTest.patient = patientDetail._id
      if (!empty) {
        newTest.test_type = patientDetail.newTestType
          ? patientDetail.newTestType
          : null
        newTest.status = patientDetail.newTestStatus
          ? patientDetail.newTestStatus
          : null
        newTest.results_date = patientDetail.newTestResultDate
          ? patientDetail.newTestResultDate
          : ''

        newTest.date = patientDetail.newTestDate
          ? patientDetail.newTestDate
          : null

        newTest.files = patientDetail.newTestFile
          ? [patientDetail.newTestFile]
          : []
        newTest.notes = {}
        newTest.notes.report = patientDetail.newTestReportNote
          ? patientDetail.newTestReportNote
          : ''
        newTest.notes.physical = ''
        newTest.notes.current_condition = ''

        Object.keys(newTest).map((key, i) => {
          if (newTest[key] === null) {
            createFlag = createFlag && false
          }
        })
      }
      if (empty) {
        newTest.test_type = patientDetail.nextStep
          ? patientDetail.nextStep
          : null
        createFlag = createFlag && newTest.test_type
        newTest.status = null
        newTest.date = patientDetail.expectedResultDate
          ? patientDetail.expectedResultDate
          : null
        createFlag = createFlag && newTest.test_type != ''
      }

      if (createFlag) {
        createExam(newTest)
          .then(response => {
            delete patientDetail.newTestType
            delete patientDetail.newTestStatus
            delete patientDetail.newTestResultDate
            delete patientDetail.newTestDate
            delete patientDetail.newTestFile
            delete patientDetail.newTestReportNote
            delete patientDetail.nextStep
            delete patientDetail.expectedResultDate
            return patientDetail._id
          })
          .then(id => {
            getExamsOfPatient(id).then(
              exams => {
                patientDetail.exams = exams
                patientDetail.exams.map(test => {
                  if (test.data) {
                    test.data.IMPcustom = []
                    if (test.data.IMP.length < 16) {
                      test.data.typeImage = 'FALSE'
                    }
                    if ((test.data.IMP.length = 16)) {
                      test.data.typeImage = 'FOUR'
                    }
                    if (
                      test.data.IMP.length > 16 &&
                      test.data.IMP.length <= 20
                    ) {
                      test.data.typeImage = 'FIVE'
                    }
                    if (test.data.IMP.length > 20) {
                      test.data.typeImage = 'SIX'
                    }
                    test.data.IMP.map(imp => {
                      let temp = 0
                      imp.ID.map(k => {
                        temp += parseInt(k)
                      })
                      test.data.IMPcustom.push(temp)
                    })
                  }
                })
                dispatch({
                  type: GET_DETAIL,
                  payload: patientDetail
                })
                resolve()
              },
              error => {
                dispatch({
                  type: GET_DETAIL,
                  payload: error
                })
                reject()
              }
            )
          })
      } else {
        patientDetail.showPopupConfirm = true
        delete patientDetail.newTestType
        delete patientDetail.newTestStatus
        delete patientDetail.newTestResultDate
        delete patientDetail.newTestDate
        delete patientDetail.newTestFile
        delete patientDetail.newTestReportNote

        dispatch({
          type: GET_DETAIL,
          payload: patientDetail
        })
      }
    })
  }
}

export function changePage(route) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      browserHistory.push(route)
      resolve()
    })
  }
}
export function deleteTest(arr) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let arrDel = arr
      api
        .delete('/exams', arrDel)
        .then(response => {
          return patientDetail._id
        })
        .then(id => {
          getExamsOfPatient(id).then(
            exams => {
              patientDetail.exams = exams
              patientDetail.exams.map(test => {
                if (test.data) {
                  test.data.IMPcustom = []
                  if (test.data.IMP.length < 16) {
                    test.data.typeImage = 'FALSE'
                  }
                  if ((test.data.IMP.length = 16)) {
                    test.data.typeImage = 'FOUR'
                  }
                  if (test.data.IMP.length > 16 && test.data.IMP.length <= 20) {
                    test.data.typeImage = 'FIVE'
                  }
                  if (test.data.IMP.length > 20) {
                    test.data.typeImage = 'SIX'
                  }
                  test.data.IMP.map(imp => {
                    let temp = 0
                    imp.ID.map(k => {
                      temp += parseInt(k)
                    })
                    test.data.IMPcustom.push(temp)
                  })
                }
              })
              dispatch({
                type: GET_DETAIL,
                payload: Object.assign({}, patientDetail, {
                  showPopupEditResult: false
                })
              })
              resolve()
            },
            error => {
              dispatch({
                type: GET_DETAIL,
                payload: error
              })
              reject()
            }
          )
        })
    })
  }
}
export function updateResult() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let tempExam = []
      let delExam = []
      patientDetail.editResult.map(k => {
        if (!k.delete) {
          let x = {}
          x._id = k._id
          x.patient = patientDetail._id
          x.status = k.status
          x.result = k.result
          tempExam.push(x)
        } else {
          delExam.push({ _id: k._id })
        }
      })
      // console.log("delExam", delExam)
      dispatch(deleteTest(delExam))
      api.put('/exams/patients', tempExam).then(
        response => {
          dispatch({
            type: UPDATE_PATIENT_DETAIL_STATE,
            payload: Object.assign({}, patientDetail, {
              showPopupEditResult: false
            })
          })
          resolve()
        },
        error => {
          dispatch({
            type: UPDATE_PATIENT_DETAIL_STATE,
            payload: error
          })
          reject()
        }
      )
    })
  }
}

export function updateHistoryState(key, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      if (!patientDetail.history) {
        patientDetail.history = {}
      }
      if (key === 'height' || key === 'weight') {
        value = value.replace(/[^0-9.]+/g, '')
      }
      patientDetail.history[key] = value
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
      resolve()
    })
  }
}

export function updateProfileAPI() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      let exams = patientDetail.exams ? patientDetail.exams : []
      if (
        patientDetail.profileUpdateDate.emailUnValid ||
        patientDetail.profileUpdateDate.phoneUnValid ||
        patientDetail.profileUpdateDate.name.firstNameUnValid ||
        patientDetail.profileUpdateDate.name.lastNameUnValid
      ) {
        dispatch({
          type: UPDATE_PATIENT_DETAIL_STATE,
          payload: patientDetail
        })
        window.scrollTo(0, 0)
        return resolve()
      }
      let dataUpdate = {
        patient: {
          _id: patientDetail._id,
          profile: patientDetail.profileUpdateDate
        }
      }
      api.put('/patients', dataUpdate).then(
        response => {
          let temp = response.patient
          let address = temp.profile.address
          temp.results = []
          patientDetail = temp
          patientDetail.profile.date = {}
          patientDetail.profile.date.dob = patientDetail.profile.dob
            ? moment(patientDetail.profile.dob).format(dateFormat)
            : false
          patientDetail.profile.date.last_visit = patientDetail.profile
            .last_visit
            ? moment(patientDetail.profile.last_visit).format(dateFormat)
            : false
          patientDetail.profile.date.next_visit =
            patientDetail.profile.next_visit &&
            patientDetail.profile.next_visit.appt_date
              ? moment(patientDetail.profile.next_visit.appt_date).format(
                  dateFormat
                )
              : false
          patientDetail.showEditProfilePopup = false
          patientDetail.showDeletePatientPopup = false
          patientDetail.exams = exams
          dispatch({
            type: UPDATE_PATIENT_DETAIL_STATE,
            payload: patientDetail
          })
          resolve()
        },
        err => {
          // console.log(err);
          reject()
        }
      )
    })
  }
}

export function updateHistoryAPI() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail.showEditHistoryPopup = !patientDetail.showEditHistoryPopup
      let dataUpdate = {
        patient: {
          _id: patientDetail._id,
          history: patientDetail.history
        }
      }
      api.put('/patients', dataUpdate).then(
        response => {
          dispatch({
            type: UPDATE_PATIENT_DETAIL_STATE,
            payload: patientDetail
          })
          resolve()
        },
        err => {
          // console.log(err);
        }
      )
    })
  }
}

export function updateExamStatus(exam, statusValue) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      if (statusValue == 'delete') {
        patientDetail.editResult.map((k, i) => {
          if (k._id == exam._id) {
            k.delete = true
          }
        })
      } else {
        statusValue = statusValue - 0
        patientDetail.editResult.map((k, i) => {
          if (k._id == exam._id) {
            if (exam.test_type && exam.test_type.toLowerCase() == 'instapap') {
              statusValue = statusValue > 1 ? 1 : statusValue
              k.result = statusValue
            } else {
              k.status = statusValue + 1
            }
          }
        })
      }
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
    })
  }
}

const initialState = {
  open: true,
  showEmailForm: true
}

export function clearState() {
  return (dispatch, getState) => {
    return new Promise((reolve, reject) => {
      var patientDetail = { ...getState().patientDetail }
      patientDetail = {
        open: true,
        showEmailForm: true
      }
      dispatch({
        type: UPDATE_PATIENT_DETAIL_STATE,
        payload: patientDetail
      })
    })
  }
}

export function updatePatientExams(data) {
  console.log('updatePatientExams...');

  return (dispatch, getState) => {
    var patientDetail = { ...getState().patientDetail }
    let exam = data !== 'undefined' ? data : patientDetail.currentTest;
    updatePatientState('updateExams', exam);
    dispatch({
      type: UPDATE_PATIENT_EXAMS,
      payload: Object.assign({}, patientDetail, {
        exams: patientDetail.exams.concat(exam)
      })
    })
  }
}

export function patientDetail() {
  return initialState
}

const ACTION_HANDLERS = {
  [GET_DETAIL]: (state, action) => action.payload,
  [UPDATE_PATIENT_DETAIL_STATE]: (state, action) => action.payload,
  [TEXT_CHANGE]: (state, action) => action.payload,
  [UPDATE_PATIENT_EXAMS]: (state, action) => action.payload,
  [CLOSE_DIALOG]: (state, action) => action.payload
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/PatientDetail/modules/patientDetail.js